// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"239":"a1dd3fd3","432":"a1dd3fd3","504":"a1dd3fd3","618":"a1dd3fd3","683":"a1dd3fd3","764":"a1dd3fd3","981":"a1dd3fd3"}[chunkId] + ".chunk.css";
};